export default __webpack_public_path__ + "static/media/gemini.1adb2d34.png";